/** The minimal shape this constraint reads: only `isCreation` drives whether the key is mandatory. */
type ApiKeyRequirementShape = {
	readonly isCreation: boolean;
};

/**
 * Generic over the minimal shape it reads, not over `AiProviderFormData` itself, so the FormData never
 * has to import its own constraint back (`guides/forms.md` §1.1). The server never re-serves a
 * registered key, on any route: its absence on an edit means "keep the one already registered," so a
 * key is only mandatory the first time a provider is declared.
 */
function isApiKeyProvided<T extends ApiKeyRequirementShape>(value: string, formData: T): boolean {
	if (!formData.isCreation) {
		return true;
	}

	return value !== '';
}

export default isApiKeyProvided;
